const prefix = 'templates'

export const SET_TEMPLATES = `${prefix}/SET_TEMPLATES`
export const SET_SELECTED_TEMPLATE = `${prefix}/SET_SELECTED_TEMPLATE`
export const SET_PER_PAGE = `${prefix}/SET_PER_PAGE`
export const SET_SEARCH = `${prefix}/SET_SEARCH`
